import script from "./Library.vue?vue&type=script&setup=true&lang=js"
export * from "./Library.vue?vue&type=script&setup=true&lang=js"

import "./Library.vue?vue&type=style&index=0&id=f4b74e64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4b74e64"]])

export default __exports__